import styled from 'styled-components';


const MainContainer = styled.div`
    margin: 10px;
`;

export {
    MainContainer
};